/**
 * Hook for searching relay threads with debounced input.
 * Only queries when the search term is at least 2 characters.
 */

import {useQuery} from '@tanstack/react-query';
import {useRequiredTenantId} from '@/matic/hooks/useRequiredTenantId';
import {useDebounce} from '@/matic/hooks/useDebounce';
import {getRelayApi} from '../api/relay-api';
import {relayKeys} from '../query-keys';
import type {ThreadListResponse} from '../types/relay-types';

export function useThreadSearch(query: string) {
  const tenantId = useRequiredTenantId();
  const api = getRelayApi();
  const debouncedQuery = useDebounce(query);

  return useQuery<ThreadListResponse>({
    queryKey: relayKeys.threads.search(debouncedQuery, tenantId),
    queryFn: async () => api.searchThreads(debouncedQuery),
    enabled: debouncedQuery.length >= 2,
  });
}
